import { API } from './constant';
import { HttpRequest } from '../../lib/http';
import { FORM_VALUE_INTER } from '../project-item-create/constant';

export const updateProject = (id: string, payload: FORM_VALUE_INTER) => {
  return HttpRequest({
    method: API.UPDATE.TYPE,
    url: API.UPDATE.URL(id),
    data: payload,
  });
};
